import React from "react";

import {
  Route,
  Redirect,
  Switch,
  BrowserRouter as Router,
} from "react-router-dom";

const RouteView = (props) => {
  return (
    <Router basename={process.env.REACT_APP_APP_BASE || "/"}>
      <Switch>
        {props.routes.map((item, index) =>
          item.path ? (
            <Route
              path={item.path}
              key={index}
              render={(pro) => {
                document.title = "车轮滚滚-" + item.title || "车轮滚滚";
                return (
                  <item.component
                    {...pro}
                    routes={item.children ? item.children : []}
                  >
                    <RouteView routes={item.children} />
                  </item.component>
                );
              }}
            />
          ) : (
            <Redirect from={item.from} to={item.to} key={index} />
          )
        )}
      </Switch>
    </Router>
  );
};

export default RouteView;
